import { render } from "./SellsyInformationsSection.vue?vue&type=template&id=04c7792a&scoped=true"
import script from "./SellsyInformationsSection.vue?vue&type=script&lang=js"
export * from "./SellsyInformationsSection.vue?vue&type=script&lang=js"

import "./SellsyInformationsSection.vue?vue&type=style&index=0&id=04c7792a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c7792a"]])

export default __exports__